export default function SectionTitle({ title }: { title: string }) {
  return (
    <div className='header-container'>
      <p className='text-[48px] italic header-text'>{title}</p>
    </div>
  );
}
